"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDates = require("react-dates");
var R = _interopRequireWildcard(require("ramda"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _hexRgb = _interopRequireDefault(require("hex-rgb"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = _interopRequireDefault(require("./styles"));
var _excluded = ["availableDates", "getDayProps"];
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Day = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    color: ", ";\n    background-color: ", ";\n"])), function (_ref) {
  var isAvailable = _ref.isAvailable,
    modifiers = _ref.modifiers;
  return R.and(isAvailable, !R.any(function (modifier) {
    return R.includes(modifier, ['selected-start', 'selected-end', 'selected-span']);
  }, modifiers)) ? '#27AE60' : undefined;
}, function (_ref2) {
  var modifiers = _ref2.modifiers,
    theme = _ref2.theme;
  return R.call(R.cond([[R.any(function (modifier) {
    return R.includes(modifier, ['selected-start', 'selected-end']);
  }), R.always(theme.primaryColor)], [R.any(function (modifier) {
    return R.includes(modifier, ['selected-span', 'hovered-span']);
  }), R.always((0, _hexRgb.default)(theme.primaryColor, {
    alpha: 0.8,
    format: 'css'
  }))]]), modifiers);
});
var DatesRangeControl = function DatesRangeControl(_ref3) {
  var _ref3$availableDates = _ref3.availableDates,
    availableDates = _ref3$availableDates === void 0 ? [] : _ref3$availableDates,
    getDayProps = _ref3.getDayProps,
    props = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.datepicker
  }, /*#__PURE__*/_react.default.createElement(_reactDates.DayPickerRangeController, _extends({
    renderDayContents: function renderDayContents(day, modifiers) {
      return /*#__PURE__*/_react.default.createElement(Day, _extends({
        className: _styles.default.customDay,
        isAvailable: R.includes(day.format('YYYY-MM-DD'), availableDates),
        modifiers: _toConsumableArray(modifiers)
      }, getDayProps(day, modifiers)), day.format('DD'));
    }
  }, props)));
};
DatesRangeControl.propTypes = {
  availableDates: _propTypes.default.arrayOf(_propTypes.default.string),
  getDayProps: _propTypes.default.func
};
DatesRangeControl.defaultProps = {
  getDayProps: function getDayProps() {
    return undefined;
  }
};
var _default = exports.default = (0, _react.memo)(DatesRangeControl);